import React, { useEffect, useRef } from "react";
import { Button, ButtonProps } from "@xometry/xometry_loft";
import { track } from "../../utils/analytics";
import { navigateToUrl } from "../../utils/contentUtils";
import clsx from "clsx";

type CTAProps = {
  onClickFunction?: () => void;
  pageSection: string;
  ctaText: string;
  action?: string | null;
  linkURL?: string | null;
  target?: string | null;
  className?: string;
  driftBotInteractionID?: number | null;
  additionalEventProps?: {};
} & ButtonProps;

const CTA = (props: CTAProps) => {
  const eventName = "CTA Clicked";
  const {
    pageSection,
    ctaText,
    action,
    linkURL,
    target,
    driftBotInteractionID,
    additionalEventProps,
    onClickFunction,
    disabled,
    children,
    className,
  } = props;

  const submitButton = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (submitButton?.current && disabled != undefined) {
      submitButton.current.disabled = disabled;
    }
  }, [submitButton]);

  let buttonClasses = "!text-base !px-4 !py-2 !rounded";

  switch (props.scale) {
    case "xsmall":
      buttonClasses = "!text-xs !px-2 !py-0 !rounded";
      break;
    case "small":
      buttonClasses = "!text-sm !px-2 !py-1 !rounded";
      break;
    case "medium":
      buttonClasses = "!text-base !px-4 !py-2 !rounded";
      break;
    case "large":
      buttonClasses = "!text-lg !px-8 !py-3 !rounded";
      break;
    case "xlarge":
      buttonClasses = "!text-xl !px-8 !py-4 !rounded";
      break;
  }

  return (
    <Button
      ref={submitButton}
      kind={props.kind}
      scale={props.scale}
      id={props.id}
      type={props.type}
      className={clsx([className, buttonClasses])}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        track(eventName, {
          page_section: pageSection,
          cta_text: ctaText,
          action: action,
          link_URL: linkURL,
          drift_bot_interaction_id: driftBotInteractionID,
          ...additionalEventProps,
        });
        e.stopPropagation();
        switch (action) {
          case "Launch Drift Bot":
            if (driftBotInteractionID)
              window.drift.api.startInteraction({
                interactionId: driftBotInteractionID,
              });
            break;
          case "Open URL":
            navigateToUrl(linkURL, target);
            break;
          default:
            navigateToUrl(linkURL, target);
        }
        if (onClickFunction) onClickFunction();
      }}
    >
      {/* Children is before cta text to allow for icons to prepend text */}
      {children}
      {props.ctaText}
    </Button>
  );
};

export default CTA;
